var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',[_c('li',{staticClass:"link_button"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n              Requerimento LGPD - MPT\n            ")])],1),_vm._v(" "),_c('li',{staticClass:"link_button"},[_c('router-link',{attrs:{"to":"/acompanhamento-requerimento"}},[_vm._v("\n              Acompanhamento Requerimento\n            ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f28ff9e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 347
// module chunks = 0